// @flow
const selectedConfig = require('./selectedConfig');
const currentEnv = require('./env');

type EnvConfigType = {|
  env: string,
  getEnvs: () => string[],
  getEnvConfig: string => EnvConfigType,
|} & ShippingConfigType;


const getEnvs = (): string[] => selectedConfig.envSpecific ? Object.keys(selectedConfig.envSpecific) : ['dev', 'stage', 'prod'];
const getEnvConfig = (env: string): EnvConfigType => {
  let config: EnvConfigType = {
    env,
    ...selectedConfig,
    // ...selectedConfig.envSpecific[env],
  };

  return config;
};

let config: EnvConfigType = getEnvConfig(currentEnv);

if (process.env.NODE_ENV === 'test') {
  const demoConfig = require('./shippingConfig/kaizen');
  // demoConfig.envSpecific is deleted by kaizen.js before export (after merging the
  // active env into the config object). Guard against this so tests don't crash.
  if (demoConfig.themes && demoConfig.themes[0]) {
    demoConfig.themes[0].translations = {}; // disable custom translations in test
  }
  config = {
    ...demoConfig,
    // envSpecific is already merged into demoConfig by kaizen.js — spread safely
    ...(demoConfig.envSpecific ? demoConfig.envSpecific.dev : {}),
    currency: '€',
    hidePendingOrderPanelOnDashboard: false,
    displayDeliveryStatusInPendingDeliveryPanel: 'none',
    isRioNumberDisplayed: true,
    askPersonalInformationDuringOrderSim: true,
    askMiddleName: true,
    canCustomersHaveActivationBonuses: false,
    areCheatCodesEnabled: false,
  };
}

config.getEnvs = getEnvs;
config.getEnvConfig = getEnvConfig;
module.exports = config;
